import React, { useRef } from 'react';
import '../styles/Template1.css';
import logo from '../uploads/logo.png';
import avatar from '../uploads/avatar.png';
import earth from '../uploads/earth.png';
import { Tour } from 'antd';

const Template1 = ({ formData, educationData, languageData, computerSkillsData, employmentData, setPhoto, setIsPhotoUploaded, setFormData, open, setOpen, setShowPhotoCropperModal, registrationAddress }) => {
    const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
	let birthPlace = `${formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name.charAt(0).toUpperCase() + formData.BirthPlace.Country.Name.slice(1).toLowerCase() : ''}${formData.BirthPlace.City ? `, ${formData.BirthPlace.City}` : ''}`;
    let regAddress = registrationAddress.ViewAddresses.split(',');
    registrationAddress.ViewAddresses = '';
    regAddress.map((item, index)=> {
        if(index == 0) {
            registrationAddress.ViewAddresses += item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
        } else registrationAddress.ViewAddresses += `,${item}`;
    })
    const ref1 = useRef(null);

    const formatDate = (date) => {
        const rawDate = date.split('T')[0];
        const dateParts = rawDate.split('-');
        return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    }

    const steps = [
        {
        title: 'Замена фото',
        description: 'Вы можете заменить фото в резюме просто нажав на текущее фото.',
        // cover: (
        //     <img
        //     alt="tour.png"
        //     src="https://user-images.githubusercontent.com/5378891/197385811-55df8480-7ff4-44bd-9d43-a7dade598d70.png"
        //     />
        // ),
        target: () => ref1.current,
        nextButtonProps: { children: 'Понятно' }
        }
    ];

	return (
		<>
		<div className="template1-container">
            <Tour open={open} onClose={() => setOpen(false)} steps={steps} />
            <img src={logo} style={{ height: '11.4mm', opacity: '.6' }} alt='logo' />
            <h1 className='center'>{formData.AnalogName}</h1>
            {/* <img ref={ref1} src={imageUrl} className='avatar' alt='avatar' ></img> */}
            <div className='template1-header'>
                <img ref={ref1} onClick={() => setShowPhotoCropperModal(true)} src={imageUrl} className='avatar' alt='avatar' ></img>
                <table className='template1-table' style={{ position: 'relative' }}>
                    <tbody>
                        <tr>
                            <td width={'50%'}><p>Дата рождения: {formData.BirthDate}</p></td>
                            <td width={'50%'}><p>Место рождения: {birthPlace}</p></td>
                        </tr>
                        <tr>
                            <td><p>Контактные телефоны: {formData.MobilePhoneWork.value}</p></td>
                            <td><p>Почтовый адрес: {formData.EmailPersonal}</p></td>
                        </tr>
                        <tr>
                            <td><p>Адрес: {registrationAddress.ViewAddresses}</p></td>
                            <td><p>Семейное положение: {formData.MaritalStatus.Name}</p></td>
                        </tr>
                        <tr>
                            <td><p>Паспортные данные: {formData.Passport.DocSeries} {formData.Passport.DocNumber}</p></td>
                            <td><p style={{ textTransform: 'capitalize' }}>Гражданство: {formData.Citizenship.Name.toLowerCase()}</p></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {/* <p style={{ marginTop: '35px', display: 'block', fontSize: '11pt' }}>О себе</p> */}
            <h4 className='template1-title' style={{ marginTop: '55px' }}>ОПЫТ РАБОТЫ</h4>
            <div className='employment-box' >
                {employmentData.map((employment, index) => (
                    // <div className='employment-row' key={`emp${index}`}>
                    //     <h6 style={{ fontSize: '11pt' }}>С {formatDate(employment.EmploymentDate)} по {employment.DismissalDate === '3999-12-31T00:00:00' ? '' : formatDate(employment.DismissalDate)}</h6>
                    //     {employment.InGroupActivity ? (
                    //         <h5 style={{ fontSize: '11pt', textTransform: 'uppercase' }}>
                    //             {employment.Position}, {employment.Division}, {employment.Departament}
                    //         </h5>
                    //     ) : (
                    //         <h5 style={{ fontSize: '11pt', textTransform: 'uppercase' }}>
                    //             {employment.Position}
                    //         </h5>
                    //     )}
                    //     {/* <h5 style={{ fontSize: '11pt', textTransform: 'uppercase' }}>{employment.Position}, {employment.Division}, {employment.Departament}</h5> */}
                    //     <p style={{ fontSize: '13pt', textTransform: 'uppercase' }}>{employment.Organization}</p><br/>
                    //     <p style={{ fontSize: '11pt' }}>{employment.Duties}</p><br/>
                    // </div>   
                    <div className='employment-row' key={`emp${index}`}>
                        {employment.InGroupActivity ? (
                            <h5 style={{ fontSize: '12pt' }}>
                                {employment.Position}, {employment.Division}, {employment.Departament}
                            </h5>
                        ) : (
                            <h5 style={{ fontSize: '12pt' }}>
                                {employment.Position}
                            </h5>
                        )}
                        <h5 style={{ fontSize: '12pt' }}>{employment.Organization} | {formatDate(employment.EmploymentDate)} - {employment.DismissalDate === '3999-12-31T00:00:00' ? 'Н.В.' : formatDate(employment.DismissalDate)}</h5>
                        <h5 style={{ fontSize: '12pt' }}>{employment.Duties}</h5><br/>
                    </div>                  
                ))}
            </div>
            <h4 className='template1-title' style={{ marginTop: '35px' }}>ОБРАЗОВАНИЕ</h4>
            <div className='education-box' >
                {educationData.map((edu, index) => (
                    // <div className='education-row' key={`edu${index}`}>
                    //     <h6 style={{ fontSize: '11pt' }}>С {formatDate(edu.Start)} по {formatDate(edu.End)}</h6>
                    //     <h5 style={{ fontSize: '13pt' }}>{edu.Institution.Name}</h5>
                    // </div>
                    <div className='education-row' key={`edu${index}`}>
                        <h5 style={{ fontSize: '12pt' }}>{edu.Institution.Name}</h5>
                        <h5 style={{ fontSize: '12pt' }}>{edu.Speciality.Name} | {edu.DocSeries+edu.DocNumber}</h5>
                        <h5 style={{ fontSize: '12pt' }}>{formatDate(edu.Start)} - {formatDate(edu.End)}</h5>
                    </div>
                ))}
            </div>
            <div className='flex-education-box'>
                <div>
                    <h4 className='template1-title' style={{ marginBottom: '15px' }}>ЗНАНИЕ ЯЗЫКОВ</h4>
                    {languageData.map((lang, index) => (
                        <p style={{ fontSize: '11pt', color: '#000' }} className='language-row' key={`lang${index}`}>{lang.Language.Name} - {lang.LanguageDegree.Name}</p>                    
                    ))}
                </div>
                <div>
                    <h4 className='template1-title' style={{ marginBottom: '15px' }}>КОМПЬЮТЕРНАЯ ГРАМОТНОСТЬ</h4>
                    {computerSkillsData.map((skill, index) => (
                        <p style={{ fontSize: '11pt', color: '#000' }} className='computer-skill-row' key={`comp${index}`}>{skill.Software.Name} - {skill.SoftwareLevel.Name}</p>
                    ))}
                </div>
            </div>
            <img src={earth} className='footer' alt='footer' />
        </div>
		</>
	);
};

export default Template1;
